import React, {
    useState,
    useRef,
    useEffect,
    useMemo,
    useCallback,
  } from "react";
  import "bootstrap/dist/css/bootstrap.css";
  import ContactLoader from "views/ContantLoader";
  import { Container } from "reactstrap";
  import "bootstrap/dist/css/bootstrap.css";
  import Tooltip from "react-bootstrap/Tooltip";
  import OverlayTrigger from "react-bootstrap/OverlayTrigger";
  import { useSelector, useDispatch } from "react-redux";
  import { setCompanyUserLoading } from "ReduxStore/Slices/companyUserSlice";
  import { getPermissions } from 'api/UsersApi'
  import SupportLink from "../Common/SupportLink";
  import {exportUsers} from 'api/ExportApi'
  
  import { getAllUsers, putUser, getUserscount } from "api/UsersApi";
  import Table from "../Table";
  import {GET , POST , PUT} from '../../api/API'
 import ContantLoader from "views/ContantLoader";
  var offSet = 0;
  var matchNextButton = 1;
  
  const AllUsers = (props) => {
    const [dataApi, setDataApi] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [createUserPermission, setCreateUserPermission] = useState(false);
    const [permissionMessage, setPermissionMessage] = useState(null);
    const [showPermissionMessage, setShowPermissionMessage] = useState(true);
  
  
    const searchText = useRef("");
  
    const { companyUserLoading } = useSelector(
      (state) => state.companyUserSetter
    );
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(setCompanyUserLoading(true));
      getPermissions().then(res => {
        // 
        setCreateUserPermission(!res['CreateUser'].allowed);
        setPermissionMessage(res['CreateUser'].message);
      })
    }, []);
  
    const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
        //dispatch(setCompanyUserLoading(true));
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        setPageIndex(pageIndex);
        await GET(`company/payments/count`)
            .then((data) => {
                setPageCount(Math.ceil(data.count / pageSize));
                setTotal(data.count);
            })
            .catch((e) => { })

          let url = dataApi.length ? `company/payments?limit=${pageSize}&offset=${dataApi[dataApi.length-1]?.id}` : `company/payments?limit=${pageSize}`
        await GET(url )
            .then((data) => {
                data.forEach((r) => {
                    r.created = new Date(r.created * 1000).toLocaleDateString()
                    r.amount = `$ ${Number(r.amount/100).toFixed(2)}`

                })
                console.log(data)
                //
                setDataApi(data);
                dispatch(setCompanyUserLoading(false));

            })
            .catch((e) => { })
    }, []);

    const data = useMemo(() => dataApi, [dataApi]);
    const columns = useMemo(
        () => [

            {
                Header: "Description",
                accessor: "description",

            },
            {
                Header: "Customer",
                accessor: "customer",

            },
            {
                Header: "Amount",
                accessor: "amount",

            },
            {
                Header: "Date",
                accessor: "created",

            },

   
        ],
        [dataApi]
    );
    const activate = (id, is) => {
  
      var status;
      if (is) status = "active";
      else status = "inactive";
      var data = {
        status: status,
      };
      putUser(id, data)
        .then((res_data) => {
          // getAllUsers(offSet)
          //   .then((data) => {
          let temp = [...dataApi];
          var x = temp.find((u) => {
            return u.id == id;
          });
          x.status = status;
          setDataApi(temp);
          // })
          // .catch((e) => 
        })
        .catch((e) => { })
    };
    const createUser = () => {
      props.history.push(`/admin/users/create`);
    };
  
    const messageBar = (permissionMessage) => {
      if (permissionMessage) {
        return (
          showPermissionMessage && <div style={{ width: '100%', height: '50px', backgroundColor: '#FEF6E6', color: 'rgb(237 146 23)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "DM Sans", fontSize: '16px', padding: '35px' }}>
            <div dangerouslySetInnerHTML={{ __html: permissionMessage }} className='messagebar__text'></div>
  
            <span onClick={() => {
              setShowPermissionMessage(false)
            }} style={{ marginLeft: '10px', fontSize: '15px', cursor: 'pointer' }}> <i className="fa fa-times"></i> </span>
          </div>
        )
      }
    }
  
    return (
      <Container>
        {messageBar(permissionMessage)}
        <SupportLink link='https://kapitalwise.com/user-guide/settings#user_setup' />
  
        <div className="page_heading" style={{ display: "flex" }}>
          <div style={{ flex: "1" }}>
            <h2>Charge and Fees</h2>
  
            <p className="sm d-flex align-items-center">
              You have {total} Payments.
            </p>
          </div>

        </div>
        <div></div>
        {dataApi ? (
          <div className="dataTableOuter">

            <div className="table-flter rdt_Pagination d-flex align-items-center">
              <span className="inline-label ml-auto">
                Page No. {pageIndex + 1} of {pageCount}
              </span>
            </div>
            {
              <Table
                columns={columns}
                data={data}
                pageCount={pageCount}
                fetchData={fetchData}
                loading={companyUserLoading}
              ></Table>
            }
          </div>
        ) : (
          <ContactLoader />
        )}
      </Container>
    );
  };
  
  export default AllUsers;
  